<template>
  <div>
    <v-dialog v-model="importPresetModal" max-width="700">
      <v-card class="py-5 px-5">
        <v-card-title class="justify-center bg-primary text-white">
          <div class="text-h6">Import presets as JSON format</div>
          <div class="text-body-2">
            Your presets will be merged with your current presets.
          </div>
        </v-card-title>
        <v-card-text class="py-5">
          <div
            v-show="wrongImportFormatError"
            class="bg-red py-2 px-2 v-card text-white mb-5"
          >
            Error when trying to import your presets. Only Stringified JSON
            formats are allowed!
          </div>
          <v-textarea
            label="Paste your presets JSON code here"
            v-model="presetCode"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!importFileBtn" @click="importFile" color="success">
            Import presets
          </v-btn>
          <v-btn @click="importPresetModal = false" color="secondary">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :model-value="dialog"
      @update:model-value="$emit('update:dialog', $event)"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 justify-center text-center">
          <div class="text-center" style="width: 100%">
            <h4 class="text-center">Save your preset locally</h4>
            <p class="text-caption text-center">
              Save your preset as a new preset or as an existing one.
            </p>
          </div>
        </v-card-title>
        <v-container class="mx-5 px-5 py-5">
          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <v-btn
                @click="exportPresets"
                variant="flat"
                class="mr-3"
                color="primary"
              >
                Export local presets
              </v-btn>
              <v-btn @click="importPresets" variant="outlined" color="primary">
                Import presets
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Preset name"
                :model-value="presetName"
                @update:model-value="setPresetName"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <SavedPresetsCombobox :key="dialog" />
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn
                block
                color="green"
                class="text-white px-5 save-preset-btn"
                rounded
                @click="savePreset(newPresetName)"
              >
                SAVE PRESET
                <v-icon class="ml-3">mdi-content-save</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                block
                color="secondary"
                variant="outlined"
                rounded
                @click="closeDialog"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import SavedPresetsCombobox from './SavedPresetsCombobox'
import { downloadFile } from '@/utils/helpers'

export default {
  name: 'Save-preset-modal',
  components: {
    SavedPresetsCombobox
  },
  data: () => ({
    presetCode: '',
    wrongImportFormatError: false,
    savedPresetFile: 'localCashierPresets.js',
    importPresetModal: false,
    newPresetName: undefined // Need to be undefined, not null for default paremeter value to work in method
  }),
  watch: {
    newPresetName(name) {
      if (name === '') {
        this.newPresetName = this.presetName
      }
    }
  },
  props: {
    dialog: { type: Boolean, required: true },
    savePreset: { type: Function, required: true },
    closeDialog: { type: Function, required: true },
    presetName: { type: String, required: true }
  },
  emits: ['update:dialog'],
  computed: {
    ...mapState({
      allPresets: ({ config }) => config.allPresets,
      preset: ({ config }) => config.preset
    }),
    importFileBtn() {
      const lengthAndString =
        this.presetCode.length > 10 && typeof this.presetCode === 'string'
      if (lengthAndString) {
        try {
          JSON.parse(this.presetCode)
        } catch {
          return false
        }
      }
      return lengthAndString
    }
  },
  methods: {
    ...mapMutations(['setPresets', 'setReloadBrowserPopUp']),
    setPresetName(name) {
      this.newPresetName = name
    },
    importFile() {
      try {
        const currentPresets = localStorage.presets
          ? JSON.parse(localStorage.presets)
          : {}
        const importedPresets =
          typeof this.presetCode === 'string'
            ? JSON.parse(this.presetCode)
            : typeof this.presetCode === 'object'
              ? this.presetCode
              : {}
        const merged = {
          ...importedPresets,
          ...currentPresets
        }
        localStorage.setItem('presets', JSON.stringify(merged))
        this.importPresetModal = false
        const newPresetsToStore = {
          ...this.allPresets,
          ...merged
        }
        this.setPresets(newPresetsToStore)
        this.setReloadBrowserPopUp()
      } catch (err) {
        this.wrongImportFormatError = true
        console.log(err)
      }
    },
    importPresets() {
      this.importPresetModal = true
    },
    exportPresets() {
      const savedPresets = localStorage.presets || JSON.stringify({})
      downloadFile(this.savedPresetFile, savedPresets)
    }
  },
  created() {
    this.setPresetName(this.preset)
  }
}
</script>

<style scoped>
.v-card-title {
  text-align: center;
}
.v-card-title h4,
.v-card-title p {
  text-align: center;
  width: 100%;
  margin: 0 auto;
}
.save-preset-btn {
  text-transform: uppercase !important;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
  background-color: #4caf50 !important;
  color: white !important;
}
.save-preset-btn .v-icon {
  color: white !important;
}
</style>
